import AxiosClient from "../../../services/axios.services";

class PerfilColaboradorServices {
    getFormacionColaborador = (params) => {
        return AxiosClient.get("/api/app/carrera_sucesion_formacion_evaluada/", {
            headers: { "Content-Type": "application/json" },
            params: params,
        });

    }

    createFormacionColaborador = (data) =>
        AxiosClient.post(
            "/api/app/carrera_sucesion_formacion_evaluada/",
            data,
            {
                headers: { "Content-Type": "application/json" },
            }
        );

    editFormacionColaborador = (id, data) =>

        AxiosClient.patch(`/api/app/carrera_sucesion_formacion_evaluada/${id}/`, data, {
            headers: { "Content-Type": "application/json" },
        });


}

export default new PerfilColaboradorServices();